import { settingApi } from '../../../slice/settingApi';

import type { listParamsType } from '../../../slice/types';

type teamParamsType = {
  ProfileURL?: string;
  id?: string;
  name?: string;
  users?: [] | string[];
  userId?: [] | string[];
  status?: string;
};

interface IUserItemResponse {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  status: string;
  createdAt: string;
}

interface ITeamItemResponse {
  id: string;
  name: string;
  users: IUserItemResponse[] | [];
  createdAt: string;
  status: string;
}

const TEAM_API = {
  list: 'api/teams/list',
  create: 'api/teams',
  update: 'api/teams',
  delete: 'api/teams',
  details: 'api/teams/details',
};

export const teamApi = settingApi.injectEndpoints({
  endpoints: (builder) => ({
    // Filter Team List => Search, Sort, Filter
    filterTeam: builder.mutation({
      query: ({ filters, globalSearch, page = 1, limit = 10 }: listParamsType) => ({
        url: TEAM_API.list,
        method: 'POST',
        body: { filters, globalSearch, page, limit },
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      transformResponse: (response: { data?: { list?: ITeamItemResponse[]; total?: number } }) => {
        const teamList = response?.data?.list?.map((item) => ({
          id: item.id ?? '',
          teamName: item.name ?? '',
          noOfUsers: item.users.length ?? 0,
          users: item.users.map((user: any) => ({
            id: user.user.id ?? '',
            username: `${user.user.firstName ?? ''} ${user.user.lastName ?? ''}`,
            firstName: user.user.firstName ?? '',
            lastName: user.user.lastName ?? '',
            email: user.user.email ?? '',
            role: user.user.role ?? '',
            joinedDate: user.user.createdAt ?? '',
            status: user.user.status ?? 'INACTIVE',
            ProfileURL: user.user.ProfileURL ?? '',
          })),
          createdDate: item.createdAt ?? '',
          updatedAt: item.createdAt ?? '',
          status: item.status,
        }));
        return { list: teamList ?? [], total: response?.data?.total ?? 0 };
      },
    }),

    // Get Team Details
    getTeamDtl: builder.mutation({
      query: ({ id }: teamParamsType) => ({
        url: `${TEAM_API.details}/${id}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      transformResponse: (response: { data?: any }) => response?.data,
    }),

    // Create Team
    createTeam: builder.mutation({
      query: ({ name, users, status }: teamParamsType) => ({
        url: TEAM_API.create,
        method: 'POST',
        body: { name, users, status },
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),

    // Update Team
    updateTeam: builder.mutation({
      query: ({ id, name, users, status, ProfileURL }: teamParamsType) => ({
        url: `${TEAM_API.update}/${id}`,
        method: 'PUT',
        body: { name, userId: users, status, ProfileURL },
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),

    // Delete Team
    deleteTeam: builder.mutation<{ success: boolean }, string>({
      query: (id) => ({
        url: `${TEAM_API.delete}/${id}`,
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),
  }),
});

export const {
  useFilterTeamMutation,
  useGetTeamDtlMutation,
  useCreateTeamMutation,
  useUpdateTeamMutation,
  useDeleteTeamMutation,
} = teamApi;
